import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle, DialogTrigger } from "../../ui/dialog";
import React, { useState } from "react";
import Button from "../../form/button";
import ErrorMessage from "../../form/errorMessage";
import { IFolderRecord, INote, Status } from "../../../lib/types";
import { Input } from "../../ui/input";
import pb from "../../../lib/pocketbase";
import { useNavigate } from "react-router-dom";

interface NewNewNote {
    folder: IFolderRecord | undefined;
}

export default function NewNote({ folder }: NewNewNote) {
    const navigate = useNavigate();
    const [name, setName] = useState("");
    const [open, setOpen] = useState(false);
    const [error, setError] = useState("");
    const [status, setStatus] = useState<Status>("none");

    function add() {
        if (!pb.authStore.model) return;
        setStatus("loading");
        const data: INote = {
            name: name,
            folder: folder?.id,
            content: "",
            user: pb.authStore.model.id,
            public: false
        };

        pb.collection("note")
            .create(data)
            .then((x) => {
                setTimeout(() => {
                    setStatus("success");
                    setError("");
                    setOpen(false);
                    navigate(`/studio/notes/note/${x.id}/edit`);
                }, 500);
            })
            .catch((err: Error) => {
                setStatus("error");
                setError(err.message);
            })
            .finally(() => {
                setTimeout(() => {
                    setStatus("none");
                }, 3000);
            });
    }

    return (
        <Dialog open={open} onOpenChange={setOpen}>
            <DialogTrigger asChild>
                <Button size="ghost" variant="ghost" className="group w-full justify-start px-6 py-4">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="h-6 w-6">
                        <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25m3.75 9v6m3-3H9m1.5-12H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 00-9-9z"
                        />
                    </svg>
                    New note
                </Button>
            </DialogTrigger>
            <DialogContent className="mt-8 md:mt-0">
                <DialogHeader>
                    <DialogTitle>New note</DialogTitle>
                </DialogHeader>
                <ErrorMessage error={error} close={() => setError("")} />
                <Input value={name} onChange={(e) => setName(e.target.value)} onKeyDown={(e) => e.key === "Enter" && add()} placeholder="Note name" />
                <DialogFooter className="gap-2">
                    <Button onClick={() => setOpen(false)}>Cancel</Button>
                    <Button status={status} onClick={() => add()} variant="dark">
                        {status === "loading" && "Adding"}
                        {status === "success" && "Added"}
                        {status === "error" && "Error"}
                        {status === "none" && "Add"}
                    </Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
}
